export default "__VITE_ASSET__D38B_Gpg__"